import { faMars, faMarsStrokeRight, faVenus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { ProgramAttendee } from '@citruscamps/citrus-client'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'
import { formatGender } from '../../../../../utils/formatters'

interface IProps {
  attendee: ProgramAttendee
}

export const AttendeeGenderSymbol = ({ attendee }: IProps) => {
  switch (attendee.gender) {
    case 'female':
      return (
        <Tooltip
          title={formatGender(attendee)}
          placement="top"
          popupProps={{ style: { zIndex: 1090 } }}
        >
          <FontAwesomeIcon icon={faVenus} className="ms-2 " />
        </Tooltip>
      )
    case 'male':
      return (
        <Tooltip
          title={formatGender(attendee)}
          placement="top"
          popupProps={{ style: { zIndex: 1090 } }}
        >
          <FontAwesomeIcon icon={faMars} className="ms-2" />
        </Tooltip>
      )
    case 'other':
      return (
        <Tooltip
          title={formatGender(attendee)}
          placement="top"
          popupProps={{ style: { zIndex: 1090 } }}
        >
          <FontAwesomeIcon icon={faMarsStrokeRight} className="ms-2" />
        </Tooltip>
      )
    case 'not_specified':
    default:
      return null
  }
}
